

























































import { RESET_PASSWORD } from "@/queries/anonymous/mutation.graphql";

import Vue from "vue";
export default Vue.extend({
  data: () => ({
    form: {
      password: "",
      confirmPassword: ""
    },
    sent: false,
    isLoading: false
  }),
  methods: {
    reset() {
      const { email, resetPasswordToken } = this.$route.query;
      if (this.form.password !== this.form.confirmPassword) {
        this.$toastr.e("Password doesn't match!", "Error");
        return;
      }
      this.isLoading = true;
      this.$apollo
        .mutate({
          mutation: RESET_PASSWORD,
          variables: {
            email,
            resetPasswordToken,
            newPassword: this.form.password
          }
        })
        .then((data: any) => {
          this.isLoading = false;
          if (data.data.resetPassword.affected_rows) {
            this.$toastr.s("Password have been reset successfuly!");
            this.$router.replace({ name: "login" });
            this.sent = true;
          }
        })
        .catch(error => {
          this.isLoading = false;
          this.$toastr.e(error.graphQLErrors[0].message);
          this.form.password = "";
          this.form.confirmPassword = "";
        });
    }
  },
  beforeRouteEnter(to, from, next) {
    const { email, resetPasswordToken } = to.query;
    console.log(to);
    if (!email || !resetPasswordToken) {
      next({ name: "reset" });
      return;
    }
    next();
  }
});
